import React from "react";
import { ReferenceInput, SelectInput } from "react-admin";

export const CommodityInput = (props) => (
	<ReferenceInput
		{...props}
		reference="commodities"
		filter={{ is_deleted: false, no_range: true }}
		sort={{ field: "name", order: "ASC" }}
		allowEmpty
	>
		<SelectInput optionText="name" />
	</ReferenceInput>
);
